import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { CouponsComponent } from './coupons.component';
import { CouponsRoutingModule } from './coupons-routing.module';
import { CouponsResolve } from './coupons.resolve';
import { CouponFormModule } from './form/coupon-form.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    CouponsRoutingModule,
    MatDialogModule,
    CouponFormModule,
    ListGridModule,
  ],
  declarations: [CouponsComponent],
  entryComponents: [],
  exports: [CouponsComponent],
  providers: [CouponsResolve],
})
export class CouponsModule {}
